export enum FontWeights {
    Light = 300,
    Normal = 400,
    SemiBold = 600,
    Bold = 700,
    ExtraBold = 800
}

export const FigtreeFontFace = {
    'font-family': 'Figtree',
    src: `url('https://hbstatic.honeybook.com/assets_system/system_web/web_fonts/Figtree-Variable.woff2') format('woff2-variations')`,
    'font-weight': '300 900'
};
